module.exports = __webpack_public_path__ + "img/Weapon_275.ebee226b.png";